// extracted by mini-css-extract-plugin
export default {"documentList":"DocumentList_documentList__dXFSV","docMeta":"DocumentList_docMeta__K2mhM","dragger":"DocumentList_dragger__JkKIh"};